import {AxiosResponse} from "axios";
import AxiosApiInstance, {APIBase} from "../AxiosApiInstance";
import ApiUploadModel from "./ApiUploadModel";

export const ApiUploadsGet: (id: string) => Promise<AxiosResponse<ApiUploadModel>> = (id) => {
  return AxiosApiInstance.get(`${APIBase}uploads/${id}/`);
};